"use client";

import Image from "next/image";
import { StatusPill } from "@/components/portfolio/StatusPill";
import { useLanguage } from "@/context/LanguageContext";

const getScenarios = (language: "cs" | "en") =>
  ({
    cs: [
      {
        title: "Vlastník bytu",
        membership: "STANDARD",
        membershipLabel: "Standardní",
        src: "/image/cta/cta1.png",
        summary: "Sledování tržní ceny nájmu bez zbytečné námahy.",
        steps: [
          "Vlastním byt 2+kk v Prostějově a chci sledovat tržní ceny pronájmů.",
          "Nastavím hlídacího psa: Pronájem | Byty | Prostějov | 2+kk | 50–70 m².",
          "E-mailová upozornění vypnu — stačí mi denní přehled na webu.",
          "Po roce upravím výši nájmu podle aktuálního trhu. Za 49 Kč / měsíc.",
        ],
      },
      {
        title: "Nájemce v Praze",
        membership: "PREMIUM",
        membershipLabel: "Prémiový",
        src: "/image/cta/cta4.png",
        summary: "Automatické sledování nabídek během pracovního dne.",
        steps: [
          "Hledám nový byt v Praze, ale nemám čas sledovat inzeráty ručně.",
          "Nastavím hlídacího psa s e-mailem každé 2 hodiny — přehled v inboxu.",
          "Přidám kritéria: energie, dispozice, dostupnost MHD.",
          "Ušetřím hodiny týdně. 89 Kč / měsíc se vrátí v čase.",
        ],
      },
      {
        title: "Investor do nemovitostí",
        membership: "PROFESSIONAL",
        membershipLabel: "Profesionální",
        src: "/image/cta/cta5.png",
        summary: "Okamžitý přehled o celé republice, rychlejší rozhodování.",
        steps: [
          "Hledám byty k rekonstrukci v Praze, Brně i Plzni současně.",
          "Aktivuji 5 hlídacích psů s vlastními kritérii pro každý region.",
          "Panel srovnání mi pomůže nastavit optimální nabídkovou cenu.",
          "249 Kč / měsíc — plná kontrola nad investičním portfoliem.",
        ],
      },
    ],
    en: [
      {
        title: "Apartment owner",
        membership: "STANDARD",
        membershipLabel: "Standard",
        src: "/image/cta/cta1.png",
        summary: "Track market rent without unnecessary effort.",
        steps: [
          "I own a 2-bedroom apartment in Prostejov and want to track rental prices.",
          "I set a watchdog: Rent | Apartments | Prostejov | 2-bedroom | 50-70 m2.",
          "I turn off email alerts - a daily web overview is enough.",
          "After a year I adjust the rent based on the current market. For 49 CZK / month.",
        ],
      },
      {
        title: "Tenant in Prague",
        membership: "PREMIUM",
        membershipLabel: "Premium",
        src: "/image/cta/cta4.png",
        summary: "Automatic listing monitoring during the working day.",
        steps: [
          "I am looking for a new apartment in Prague but do not have time to check listings manually.",
          "I set a watchdog with email every 2 hours - a quick overview in my inbox.",
          "I add criteria: utilities, layout, public transport access.",
          "I save hours every week. 89 CZK / month pays back in saved time.",
        ],
      },
      {
        title: "Real estate investor",
        membership: "PROFESSIONAL",
        membershipLabel: "Professional",
        src: "/image/cta/cta5.png",
        summary: "Instant overview across the country and faster decisions.",
        steps: [
          "I search for apartments to renovate in Prague, Brno, and Pilsen at the same time.",
          "I activate 5 watchdogs with custom criteria for each region.",
          "The comparison panel helps me set an optimal offer price.",
          "249 CZK / month - full control over an investment portfolio.",
        ],
      },
    ],
  })[language];

const WhatToChoose = () => {
  const { language } = useLanguage();
  const scenarios = getScenarios(language);
  return (
    <div className="scenarios-grid">
      {scenarios.map((s) => (
        <div key={s.title} className="component-card-non-featured">
          {/* Image */}
          <div className="scenario-img-wrap">
            <Image
              src={s.src}
              alt={s.title}
              width={600}
              height={400}
              className="scenario-img"
            />
          </div>

          {/* Body */}
          <div className="scenario-body">
            <div className="scenario-header">
              <h3 className="scenario-title">{s.title}</h3>
              <StatusPill>{s.membershipLabel}</StatusPill>
            </div>
            <p className="scenario-summary">{s.summary}</p>

            <ol className="scenario-steps">
              {s.steps.map((step, i) => (
                <li key={i} className="scenario-step">
                  <span className="scenario-step-num">{i + 1}</span>
                  <span>{step}</span>
                </li>
              ))}
            </ol>
          </div>
        </div>
      ))}
    </div>
  );
};

export default WhatToChoose;
